export default __webpack_public_path__ + "a65feb9.png";